export class RestClientNetworkError extends Error {
    readonly response: any;

    constructor(message: string, response: any) {
        super(message);
        this.name = 'RestClientNetworkError';
        this.response = response;
    }
}
